import styled from 'styled-components';
import { Toolbar } from 're-cy-cle';

export default styled(Toolbar)`
    background-color: ${({ theme }) => theme.toolbarColor};
`;
